import { formatLabel, MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH } from '@grandvisionhq/svc-tealium/utils';

const getProductTealiumDescription = (modelName, sku)=>{
    const modelNamePart = modelName ? `${formatLabel(modelName)}_` : '';
    return `${modelNamePart}${formatLabel(sku)}`.substring(0, MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH);
};

export { getProductTealiumDescription };
//# sourceMappingURL=get-product-tealium-description.js.map
